import React, { Component } from "react";
import { connect } from "react-redux";

import _ from "lodash";

import * as types from "../../Store/Actions/types";
import * as actions from "../../Store/Actions";

import {
	Button,
	Card,
	CardBody,
	CardGroup,
	Col,
	Container,
	Form,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Row
} from "reactstrap";
import { getSites } from "../../Store/Actions";
import { access } from "fs";

class Login extends Component {
	state = {
		user: null,
		gates: [],
		sites: [],
		UserName: "",
		Password: "",
		error: "",
		isProcessing: false,
		gateId: 0,
		siteId: 0
	};

	componentWillMount() {
		const { user, history } = this.props;
		if (user) {
			history.push("/");
		}
	}

	onChange = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	onSiteChange = (e, user) => {
		console.log("e", e.target.value, "user", user);
		this.setState({
			[e.target.name]: e.target.value
		});
		this.props.getSiteGates(user.token, e.target.value).then(res => {
			this.setState({ gates: res.data });
		});
	};

	changeSiteUserData = (token, params, user) => {
		const { changeSite } = this.props;
		console.log("in changeSiteUserData");
		changeSite(token, params).then(res => {
			console.log("in changeSiteUserData response", res);
			this.loginUser(res.data);
		});
	};

	loginUser = user => {
		
		let { dispatch } = this.props;
		user.gateId = this.state.gateId;

		dispatch({
			type: types.LOGIN,
			payload: user
		});

		window.location.reload();
	};

	login = () => {
		
		this.setState({
			isProcessing: true,
			error: ""
		});

		let { login, getGates, getSites } = this.props;

		const { UserName, Password } = this.state;

		login({ UserName, Password })
			.then(res => {
				
				const user = res.data;
				if (_.includes(user.Roles, "Administrator")) {
					getSites(user.token).then(res => {
						this.setState({ sites: res.data });
					});
					this.setState({ user });
				} else if (_.includes(user.Roles, "Supervisor")) {
					getSites(user.token).then(res => {
						this.setState({ sites: res.data });
					});
					this.setState({ user });
				} else if (_.includes(user.Roles, "Guard")) {
					getSites(user.token).then(res => {
						this.setState({ sites: res.data });
					});

					this.setState({ user });
				} else {
					this.loginUser(user);
				}
			})
			.catch(err => {
				let error = err.toString();

				if (err.response) {
					error = err.response.data.Message;
				}

				this.setState({ error });

				this.setState({
					isProcessing: false
				});
			});
	};

	renderError = () => {
		const { error } = this.state;

		if (error) {
			return <p className="text-danger">{error}</p>;
		}
	};

	renderSelectGate = () => {
		const { user, gateId, gates, siteId, sites } = this.state;
		const { history } = this.props;
		const params = { SiteID: siteId };
		if (user) {
			if (_.includes(user.Roles, "Guard")) {
				return (
					<Form>
						<h2>Select Site and Gate</h2>
						<p className="text-muted" />

						<InputGroup className="mb-4">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fa fa-map-marker" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								type="select"
								name="siteId"
								value={siteId}
								onChange={e => this.onSiteChange(e, user)}
							>
								<option key="" value="">
									Select Site
								</option>

								{sites.map(g => (
									<option key={g.SiteID} value={g.SiteID}>
										{g.SiteName}
									</option>
								))}
							</Input>
						</InputGroup>

						<InputGroup className="mb-4">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fa fa-map-marker" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								type="select"
								name="gateId"
								value={gateId}
								onChange={this.onChange}
							>
								<option key="" value="">
									Select Gate
								</option>

								{gates.map(g => (
									<option key={g.GateID} value={g.GateID}>
										{g.GateDescription}
									</option>
								))}
							</Input>
						</InputGroup>

						<Row>
							<Col xs="12">
								<Button
									color="primary"
									className="px-4"
									disabled={!gateId}
									onClick={() =>
										this.changeSiteUserData(
											user.token,
											params,
											user
										)
									}
								>
									Save
								</Button>{" "}
								<Button
									onClick={() => history.push("/logout")}
									color="secondary"
									className="px-4"
								>
									Back
								</Button>
							</Col>
						</Row>
					</Form>
				);
			} else {
				return (
					<Form>
						<h1>Select Site </h1>
						<p className="text-muted">Select your current site</p>

						<InputGroup className="mb-4">
							<InputGroupAddon addonType="prepend">
								<InputGroupText>
									<i className="fa fa-map-marker" />
								</InputGroupText>
							</InputGroupAddon>
							<Input
								type="select"
								name="siteId"
								value={siteId}
								onChange={this.onChange}
							>
								<option key="" value="">
									Select Site
								</option>

								{sites.map(g => (
									<option key={g.SiteID} value={g.SiteID}>
										{g.SiteName}
									</option>
								))}
							</Input>
						</InputGroup>

						<Row>
							<Col xs="12">
								<Button
									color="primary"
									className="px-4"
									disabled={!siteId}
									onClick={() =>
										this.changeSiteUserData(
											user.token,
											params,
											user
										)
									}
								>
									Save
								</Button>{" "}
								<Button
									onClick={() => history.push("/logout")}
									color="secondary"
									className="px-4"
								>
									Back
								</Button>
							</Col>
						</Row>
					</Form>
				);
			}
		}
	};

	renderLoginForm = () => {
		const { number, password, error, isProcessing, user } = this.state;

		if (!user) {
			return (
				<Form>
					<img
						src={"../../assets/img/logo.png"}
						alt="Logo"
						width="250px"
						className="img img-responsive"
					/>
					<h2>Login</h2>
					<p className="text-muted">Sign In to your account</p>
					<InputGroup className="mb-3">
						<InputGroupAddon addonType="prepend">
							<InputGroupText>
								<i className="icon-user" />
							</InputGroupText>
						</InputGroupAddon>
						<Input
							className="form-control-warning"
							type="text"
							placeholder="Username"
							autoComplete="number"
							name="UserName"
							value={number}
							onChange={this.onChange}
							invalid={error}
							onKeyPress={this.handleKeyPress}
						/>
					</InputGroup>
					<InputGroup className="mb-4">
						<InputGroupAddon addonType="prepend">
							<InputGroupText>
								<i className="icon-lock" />
							</InputGroupText>
						</InputGroupAddon>
						<Input
							type="password"
							placeholder="Password"
							autoComplete="current-password"
							name="Password"
							value={password}
							onChange={this.onChange}
							invalid={error}
							onKeyPress={this.handleKeyPress}
						/>
					</InputGroup>
					{this.renderError()}
					<Row>
						<Col xs="12" className="text-center">
							<Button
								color="primary"
								className="px-4"
								onClick={this.login}
								disabled={isProcessing}
							>
								{isProcessing ? "Please wait..." : "Login"}
							</Button>
						</Col>
					</Row>
				</Form>
			);
		}
	};

	handleKeyPress = event => {
		if (event.key === "Enter") {
			this.login();
		}
	};

	render() {
		return (
			<div className="app flex-row align-items-center">
				<Container>
					<Row className="justify-content-center">
						<Col xs="10" sm="10" md="6" lg="4" xl="4">
							<CardGroup>
								<Card className="p-4">
									<CardBody>
										{this.renderLoginForm()}
										{this.renderSelectGate()}
									</CardBody>
								</Card>
							</CardGroup>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.auth.user
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatch: dispatch,
		login: data => actions.login(data),
		changeSite: (token, params) => actions.changeSite(token, params),
		getGates: token => actions.getGates(token),
		getSites: token => actions.getSites(token),
		getSiteGates: (token, siteId) => actions.getSiteGates(token, siteId)
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Login);
